module.exports = __webpack_public_path__ + "img/tips_banner@2x.5a9bdf05.png";